/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */

import store from '@/store';
import Vue from 'vue'
import {comLegend, comColor} from "../../script/comChart";
import jsonVal from "./json/data.json";

let vm = new Vue();
let vuex = store.state;
export default {
    //类型
    type: 'indicator',
    //类别
    class: 'chart',
    //组件名称
    name: '指标',
    //排序
    sort: 8,
    //是否在多维分析展示
    viewType: true,
    //图标
    iconImg: '/img/indicator1.png',
    //大屏图标
    bigIconImg: '/img/indicator1.png',
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 0,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 0,
        //最大度量数量
        maxDLLength: 1,
        //高
        dp_height: 100,
        //宽
        dp_wight: 200,
        //最小高
        dp_min_height: 20,
        //宽宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: false,
        //是否展示度量配置
        isDlConfig: false,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: false,
        //是否展示边框
        isComBorder: false,
    },
    component: () => import('./component/indicatorCom.vue'),
    // 子集展示的配置项
    chilCharts: [
        {
            name: '指标',
            ordImg: '/img/indicator1.png',
            bigImg: '/img/indicator1.png',
            //默认配置
            chartParam: {},
            wdParam: {},
            dlParam: {
                stack: ''
            },
            //提示
            viewDpPrompt: '值只能是一个且必须是数字类型',
        }
    ],
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: null,
    //度量参数
    dlHandle(option) {
        return {}
    },
    //配置参数
    params(option) {
        return {
            show: true,
            iconSet: {
                name: 'ff_icon_jinggao',
                color: 'rgba(224, 23, 23, 1)',
                iconColor: vuex.dpType === 1 ? '#000' : '#333',
                fontSize: '48',
                position: '左侧',
                show: true,
                lineHeight:180,
            },
            paddingTop: 0,
            paddingBottom: 0,
            textSet: {
                show: true,
                paddingLeft: 20,
                paddingRight: 0,
                text: '警报数量',
                position:'left',
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    fontSize: 24,
                    fontWeight: 700,
                    fontFamily: '楷体'
                },
            },
            valSet: {
                position:'left',
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    fontSize: 30,
                    fontWeight: 700,
                    fontFamily: '黑体'
                },
                val: '',
            },
        }
    },
    //右侧图表配置组件列表
    configModule: [
        {
            name: '指标配置',
            component: () => import('./config/indicator_config.vue')
        },
        {
            name: '图标配置',
            component: () => import('./config/indicatorIcon_config.vue')
        },
        {
            name: '文字配置',
            component: () => import('./config/indicatorText_config.vue')
        },
    ],
    //接口
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度'],
            //度量
            dl: ['度量']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;
            let wd = params.wd;
            let dlStyParam = setChart.dlStyParam;
            let head = {
                listWD: [],
                listZB: []
            };

            let dt = JSON.parse(json);

            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;

        } catch (e) {
            chart.data = {};
        }
    },
    renderBefore(chart, nowChart) {
        nowChart.comConfig.gridType =null;
    },
    //渲染
    rendering(chart, nowChart) {
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        let config = chart.setting;
        let params = config.params;
        //度量
        let dl = dataAll.head.listZB;
        let dlParams = config.dlList;
        //数据 转换成正常格式
        let dataVal = dataAll.dt;
        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
            }
            dataVal[index] = da;
        });
        //获取度量数据
        let dlVal = [];
        dl.map((i, index) => {
            let configDL = {};
            dlParams.map((c) => {
                if (c.name === i.filed) {
                    configDL = c;
                }
            });
            dataVal.map((item) => {
                dlVal.push({
                    value: item[i.alias],
                    config: configDL,
                });
            });
        });

        if (dlVal.length == 1 && typeof dlVal[0].value == 'number') {
            params.valSet.val = dlVal[0].value;
        } else {
            params.valSet.val= NaN;
        }
        store.dispatch('screenSaveChart');
    }
}
